import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import { VueAxios } from '@/utils/request' // axios 不建议引入到 Vue 原型链上

import moment from 'moment'
// import 'ant-design-vue/node_modules/moment/locale/zh-cn';
// moment.locale('zh-cn');
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts
// import china from '@/assets/json/china.json'  //此处填上面内容创建的china.json文件的路径
// Vue.prototype.$echarts = echarts
// console.log('echarts',echarts);
// echarts.registerMap('china', china)

  //main.js中的内容
  import echarts from 'echarts';
  Vue.prototype.$echarts = echarts;

import './core/use'
import bootstrap from './core/bootstrap'
import '@/permission' // permission control
import '@/utils/filter' // global filter

Vue.config.productionTip = false;

Vue.filter('timeFormat', function (value) {
  if(!value) return '-';
  return moment(value*1000).format('YYYY-MM-DD HH:mm:ss');
});
 
 window.getFormatDate_XLSX = function(serial){
    var utc_days = Math.floor(serial - 25569);
    var utc_value = utc_days * 86400;
    var date_info = new Date(utc_value * 1000);
    var fractional_day = serial - Math.floor(serial) + 0.0000001;
    var total_seconds = Math.floor(86400 * fractional_day);
    var seconds = total_seconds % 60;
    total_seconds -= seconds;
    var hours = Math.floor(total_seconds / (60 * 60));
    var minutes = Math.floor(total_seconds / 60) % 60;
    var d = new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
    //得到Date()对象后，便可进行日期格式化了！
    var add0 = (m) => m < 10 ? '0' + m : m;
    // var d = getFormatDate_XLSX(44358.9999884259);
    var YYYY = d.getFullYear();
    var MM = add0(d.getMonth() + 1);
    var DD = add0(d.getDate());
    var hh = add0(d.getHours());
    var mm = add0(d.getMinutes());
    var ss = add0(d.getSeconds());
    return `${YYYY}-${MM}-${DD} ${hh}:${mm}:${ss}`;
    // return d;
 }
 
Vue.filter('price', function (value) {
  return value;
  return (value/100).toFixed(2);
});

Vue.filter('toThousands', function (num) {
  // return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  return (num+ '').replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g,'$1,');
});

Vue.use(VueAxios, router)

new Vue({
  router,
  store,
  created () {
    bootstrap()
  },
  render: h => h(App)
}).$mount('#app')
